import Grid from '@enlighten/design-system/dist/Grid2';

import variables from '@/styles/variables.module.scss';

import Info from './Info';
import SiteMap from './SiteMap';

export default function Footer() {
	return (
		<Grid container justifyContent="center" bgcolor="common.white" borderTop={`1px solid ${variables.grey300}`}>
			<Grid container direction="column" width="100%" maxWidth={1440} borderTop={`1px solid ${variables.grey300}`}>
				<SiteMap />
				<Info />
			</Grid>
		</Grid>
	);
}
